import utils, { IAPIHeaders } from '../API/utils';
import { USER_TYPES } from '../constants/common';
import { MEMBER_DATA_SOURCE } from '../constants/memberConstants';
import { ROUTES } from '../constants/routes';
import { useAppContext } from '../store';
import { useAEMContext } from '../store/aemStore';
import { API_STATUS_TYPES } from '../store/constants';
import { COMMON_COMPONENTS, PAGE_NAME } from './constants';
import { fetchFromContentService, parseAll } from './utils';

export interface IContentService {
  state: string;
  language: string;
  pageName: string;
}

const useAEM = () => {
  const { setAPIStatus, language } = useAppContext();
  let { stateCode } = useAppContext();
  const {
    setAEMScreenContent,
    setAEMCommonContent,
    AEMCommonContent,
    AEMScreenContent,
    setUserBasedAlertDetails,
    userBasedAlertDetails,
  } = useAEMContext();

  const getPageSpecificContent = (
    pageKey: PAGE_NAME,
    headers?: IAPIHeaders,
  ) => {
    if (headers?.STATE_CODE) {
      stateCode = headers?.STATE_CODE;
    }
    if (!AEMScreenContent[pageKey].isLoaded) {
      fetchFromContentService(pageKey, language, stateCode, true)
        .then((res) => {
          if (res && res.response) {
            setAEMScreenContent(
              {
                ...AEMScreenContent,
                [pageKey]: {
                  ...parseAll(res.response, pageKey),
                  isLoaded: true,
                },
              },
              pageKey,
            );
          }
        })
        .catch((err) => {
          setAPIStatus(API_STATUS_TYPES.SHOW_ERROR_SCREEN, '');
          setAEMScreenContent(
            {
              ...AEMScreenContent,
              [pageKey]: {
                ...AEMScreenContent[pageKey],
                error: err,
                isLoaded: false,
              },
            },
            pageKey,
          );
        });
    }
  };

  const getCommonContent = (
    pageKey: COMMON_COMPONENTS,
    headers?: IAPIHeaders,
    caGovtStateCode?: string,
  ) => {
    if (pageKey === COMMON_COMPONENTS.HOURS_OF_OPERATION) {
      stateCode = headers?.STATE_CODE || stateCode;
    }
    stateCode = caGovtStateCode || stateCode;
    if (!AEMCommonContent[pageKey].isLoaded) {
      fetchFromContentService(pageKey, language, stateCode, false, headers)
        .then((res) => {
          if (res && res.response) {
            setAEMCommonContent(
              {
                ...AEMCommonContent,
                [pageKey]: {
                  ...parseAll(res.response, pageKey),
                  isLoaded: true,
                },
              },
              pageKey,
            );
          }
        })
        .catch((err) => {
          setAPIStatus(API_STATUS_TYPES.SHOW_ERROR_SCREEN, '');
          setAEMCommonContent(
            {
              ...AEMCommonContent,
              [pageKey]: {
                ...AEMCommonContent[pageKey],
                error: err,
                isLoaded: false,
              },
            },
            pageKey,
          );
        });
    }
  };

  const getUserBasedAlert = (
    userTypeCode: USER_TYPES,
    dataSource?: MEMBER_DATA_SOURCE,
  ) => {
    const { fetch } = utils;
    const {
      aemRoutes: { baseRoute, userBasedAlert },
    } = ROUTES;
    let headers: IAPIHeaders = { USER_TYPE_CODE: userTypeCode };
    if (dataSource) {
      headers = {
        ...headers,
        DATA_SOURCE: dataSource,
      };
    }

    fetch(`${baseRoute}${userBasedAlert}`, {
      method: 'GET',
      headers: { ...headers },
    })
      .then((res) => {
        setUserBasedAlertDetails({
          ...userBasedAlertDetails,
          ...res.response,
          isLoaded: true,
        });
      })
      .catch(() => {
        setUserBasedAlertDetails({ ...userBasedAlertDetails, isLoaded: false });
      });
  };

  return { getPageSpecificContent, getCommonContent, getUserBasedAlert };
};

export default useAEM;
